
import { BrowseExtraButton } from "@/models/browse-extra-button";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { BrowseExtraButtonService } from "@/services/browse-extra-button-service";
import { AppBrowse } from "@/utils/app-browses";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			buttons: [] as BrowseExtraButton[],
			selectedRows: [] as BrowseExtraButton[],
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		},
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "ID",
					width: "40px",
				},
				{
					name: "Browse",
					property: "BrowseID",
					width: "200px",
					print(id:number):string{
						let keys = Object.keys(AppBrowse);
						let values = Object.values(AppBrowse);
						for (let valueIndex in values){
							if (values[valueIndex] == id) {
								return keys[valueIndex];
							}
						}
						return "ERROR";
					}
				},
				{
					name: "Label",
					property: "Label",
					width: "200px"
				},
				{
					name: "Code",
					property: "Code",
					width: "400px"
				}
			];
		},
		selectedItem():BrowseExtraButton | null {
			if (this.selectedRows.length != 1) {
				return null;
			}
			return this.selectedRows[0];
		}
	},
	methods: {
		add(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/browse-extra-button/new`);
		},
		edit(){
			if (!this.selectedItem) return;
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/browse-extra-button/edit/${this.selectedItem.ID}`);
		},
		async remove(){
			let result = await this.$wf.confirm(`Weet je zeker dat je ${this.selectedRows.length} item(s) wilt verwijderen`, "Ja", "Nee");
			if (!result) return;
			for (let item of this.selectedRows){
				await BrowseExtraButtonService.deleteButton(this.value.id, item);
			}
			this.selectedRows = [];
			this.fetch();
		},
		async fetch(){
			this.buttons = await BrowseExtraButtonService.getAllButtons(this.value.id);
		},
		compare(s1:BrowseExtraButton, s2:BrowseExtraButton):boolean{
			return s1.ID == s2.ID;
		},
		onEditValue(val:BrowseExtraButton){
			this.fetch();
			this.selectedRows = [];
		}
	},
	mounted(){
		this.fetch();
	},
});
